import { render, staticRenderFns } from "./EventForm.vue?vue&type=template&id=22c5519a"
import script from "./EventForm.vue?vue&type=script&lang=js"
export * from "./EventForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports